import { isStringNumber } from './string.js';

function convertURIComponent(encodedURIComponent) {
    const value = decodeURIComponent(encodedURIComponent);
    const lowercaseValue = value.toLowerCase();
    if ([
        "false",
        "off"
    ].includes(lowercaseValue)) {
        return false;
    }
    if ([
        "true",
        "on"
    ].includes(lowercaseValue)) {
        return true;
    }
    const numericValue = Number(value.replace(/\+/g, ""));
    if (isStringNumber(numericValue)) {
        return numericValue;
    }
    return value;
}
const getUrlParameters = (url)=>{
    const newUrl = url || window.location.search.substring(1);
    const request = {};
    const pairs = newUrl.substring(newUrl.indexOf("?") + 1).split("&");
    pairs.forEach((item)=>{
        const pair = item.split("=");
        if (pair.length === 2) {
            let name = decodeURIComponent(pair[0]);
            const value = convertURIComponent(decodeURIComponent(pair[1]));
            if (name.endsWith("[]")) {
                name = name.substring(0, name.length - 2);
                if (Array.isArray(request[name])) {
                    request[name].push(value);
                } else {
                    request[name] = [
                        value
                    ];
                }
            } else if (request[name] === undefined) {
                request[name] = value;
            } else if (Array.isArray(request[name])) {
                request[name].push(value);
            } else {
                request[name] = [
                    request[name],
                    value
                ];
            }
        }
    });
    return request;
};
/**
 * Aktuális URL egy paraméterének lekérdezése
 *
 * @param name Paraméter neve
 * @param def  Alapértelmezett érték
 *
 * @return Paraméter értéke, vagy ha nincs akkor a default érték.
 */ const getUrlParameter = (name, def)=>{
    const value = getUrlParameters()[name];
    if (value === undefined) {
        return def;
    }
    return value;
};
const paramToUrlParam = (name, value)=>{
    if (Array.isArray(value)) {
        return value.filter((item)=>item !== undefined && typeof item !== "object").map((subValue)=>`${encodeURIComponent(name)}[]=${encodeURIComponent(subValue)}`).join("&");
    }
    return `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
};
const generateUrlParams = (params)=>{
    if (typeof params !== "object") {
        return undefined;
    }
    return Object.keys(params).map((name)=>({
            name,
            value: params[name]
        })).filter((param)=>Array.isArray(param.value) && param.value.length !== 0 || typeof param.value !== "object" && param.value !== undefined).map((param)=>paramToUrlParam(param.name, param.value)).join("&");
};
const addParameterToURL = (url, params)=>{
    if (typeof params !== "object") {
        return url;
    }
    const oldParams = getUrlParameters(url);
    return `${url.split("?")[0]}?${generateUrlParams({
        ...oldParams,
        ...params
    })}`;
};

export { addParameterToURL, generateUrlParams, getUrlParameter, getUrlParameters };
//# sourceMappingURL=url.js.map
